import React, { useState, useEffect } from 'react';

import './Style.css';
import ModalTrigger from '../../../shared/modal/ModalTrigger';
import { RegionContent } from '../../types/AssessmentPageItem';

type DotRadioProps = {
  questionTitle: string;
  modalText?: string;
  onSetValue: (value: { id: string; value: string }) => void;
  onOpenModal?: (html?: unknown) => void;
  questionid: string;
  assessmentValues: Record<string, unknown>;
  outerId?: string;
  width: string;
  regionContent?: RegionContent;
  type: string;
  skippable?: boolean;
  range: string;
  radioOptions?: string[];
};

export function DotRadio({
  questionTitle,
  modalText,
  onSetValue,
  onOpenModal,
  questionid,
  assessmentValues,
  outerId,
  width,
  regionContent,
  type,
  skippable,
  range,
  radioOptions,
}: DotRadioProps) {
  const [radioOption, setRadioOption] = useState<number | null>(null);

  function saveValue(event: React.ChangeEvent<HTMLInputElement>) {
    const value = Number(event.target.value);
    const { name } = event.target;

    let whoToContactOptions = [];
    if (regionContent) {
      whoToContactOptions = [
        { key: 0, value: regionContent.self_harm_box_1 },
        { key: 1, value: regionContent.self_harm_box_2 },
        { key: 2, value: regionContent.self_harm_box_3 },
        { key: 3, value: regionContent.self_harm_box_4 },
      ];
    }

    if (value === radioOption) {
      setRadioOption(null);
      onSetValue({ id: name, value: '' });
    } else {
      setRadioOption(value);
      onSetValue({ id: name, value: value.toString() });
    }

    if (name === 'self_harm' && value > 0) {
      const modalWithBoxesText = {
        questionTitle,
        main: regionContent?.self_harm_intro,
        secondary: whoToContactOptions,
      };
      onOpenModal?.(modalWithBoxesText);
    }
  }

  useEffect(() => {
    const val = assessmentValues[questionid];
    if ((val || val === '0') && radioOption === null) {
      setRadioOption(Number(val));
    }
  }, [assessmentValues, questionid, radioOption]);

  const rows = [];
  let k;
  for (let i = 0; i < parseFloat(range); i++) {
    if (parseFloat(range) !== 4 && parseFloat(range) !== 8) {
      k = i + 1;
    } else {
      k = i;
    }
    rows.push({ index: i, value: k });
  }

  return (
    <>
      {type === 'question' && (
        <div id={questionid} className={`question_block${width}${skippable ? '' : ' req'}`}>
          <fieldset
            aria-labelledby={`${outerId} ${questionid}-legend`}
            data-input-type="dot-radio-question"
          >
            <legend className="assessment_question_title" id={`${questionid}-legend`}>
              {questionTitle}
            </legend>
            {modalText && (
              <ModalTrigger
                modalText={modalText}
                onOpenModal={onOpenModal}
                question={questionid}
                questionTitle={questionTitle}
              />
            )}
            <div className="answer_block fs-exclude">
              <div className="dot_radio" id={`${questionid}-question-radio-container`}>
                {rows.map((option) => (
                  <div className="input_wrap" key={option.index}>
                    <input
                      type="radio"
                      id={questionid + option.value}
                      name={questionid}
                      value={option.value}
                      onChange={saveValue}
                      checked={String(radioOption) === String(option.value)}
                      aria-checked={String(radioOption) === String(option.value)}
                      aria-posinset={option.index + 1}
                      aria-setsize={rows.length}
                    />
                    <label htmlFor={questionid + option.value}>{option.value}</label>
                  </div>
                ))}
              </div>
            </div>
          </fieldset>
        </div>
      )}
      {type === 'gad' && (
        <div className="req">
          <fieldset
            aria-labelledby={`${outerId ? `${outerId} ${questionid}-legend` : ''}`}
            id={questionid}
            className="gad_row"
            data-input-type="dot-radio-gad"
          >
            <legend id={`${questionid}-legend`}>{questionTitle}</legend>
            {outerId && (
              <span id={`${outerId}-${questionid}-legend`} className="visuallyHidden">
                {questionTitle}
              </span>
            )}
            <div className="dot_radio fs-exclude" id={`${questionid}-gad-radio-container`}>
              {rows.map((option, index) => (
                <div className="input_wrap" key={option.index}>
                  <input
                    type="radio"
                    id={questionid + option.value}
                    name={questionid}
                    value={option.value}
                    onChange={saveValue}
                    checked={String(radioOption) === String(option.value)}
                    aria-checked={String(radioOption) === String(option.value)}
                    aria-label={`${option.value} ${radioOptions ? radioOptions[option.index] : ''}`}
                    aria-posinset={index + 1}
                    aria-setsize={rows.length}
                  />
                  <label htmlFor={questionid + option.value}>{option.value}</label>
                </div>
              ))}
            </div>
          </fieldset>
        </div>
      )}
    </>
  );
}
